import $ from 'jquery';


$(() => {
    const iOSua = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const iOSpf = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

    if (iOSua && iOSpf) {
        $('html').addClass('ios');
    }

    // since ipad now use OSX need to detect if safari have touch screen event
    if (navigator.userAgent.indexOf('Macintosh') > -1) {
        try {
            document.createEvent('TouchEvent');
            $('html').addClass('ipad');
        } catch (e) {
            $('html').addClass('mac-safari'); // do nothing for now
        }
    }
});



// WEBPACK FOOTER //
// ./src/js/utils/support.js